import React, { useMemo } from "react";

import EventLogItem from "./EventLogItem";

const EventLogItems = (props) => {
  const { events } = props;

  const displayEvents = useMemo(() => {
    let playEvents = [];
    playEvents = events.filter((el) => el.status !== "deleted");

    if (
      playEvents &&
      playEvents.length &&
      playEvents[0] &&
      playEvents[0].eventType === "substitution"
    ) {
      playEvents = playEvents.sort((a, b) => {
        if (a.subType === b.subType) {
          return b.bib - a.bib;
        }
        return a.subType < b.subType ? 1 : -1;
      });
    }

    if (playEvents) {
      return (
        <React.Fragment>
          {playEvents.map((event) => {
            return (
              <EventLogItem event={event} {...props} key={event.eventId} />
            );
          })}
        </React.Fragment>
      );
    }
    // eslint-disable-next-line
  }, [events]);

  return <React.Fragment>{displayEvents}</React.Fragment>;
};

export default EventLogItems;
